module.exports = __webpack_public_path__ + "static/img/add-video.747ac4e1.png";